export default __webpack_public_path__ + "static/media/socialdistancing.485abd63.png";